/* eslint-disable */
// Chakra Imports
import { Box, Flex, Text, useColorModeValue, IconButton } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { SidebarContext } from 'context/SidebarContext';
import { Link as RouterLink } from 'react-router-dom';
import { QuestionIcon } from '@chakra-ui/icons';

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const { sidebarCollapsed } = useContext(SidebarContext);

  useEffect(() => {
    window.addEventListener('scroll', changeNavbar);

    return () => {
      window.removeEventListener('scroll', changeNavbar);
    };
  });

  const { secondary, brandText, mini, setMini, theme, setTheme, hovered, routes } =
    props;

  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  let mainText = useColorModeValue('brand.700', 'white');
  let secondaryText = useColorModeValue('secondaryGray.700', 'white');
  let navbarPosition = 'fixed';
  let navbarFilter = 'none';
  let navbarBackdrop = 'blur(20px)';
  let navbarShadow = 'none';
  let navbarBg = useColorModeValue(
    'rgba(244, 247, 254, 0.2)',
    'rgba(11,20,55,0.5)'
  );
  let navbarBorder = 'transparent';
  let secondaryMargin = '0px';
  let paddingX = '15px';
  let gap = '0px';
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };
  return (
    <Box
      zIndex={10}
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      backgroundPosition="center"
      backgroundSize="cover"
      borderRadius="16px"
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: 'center' }}
      display={secondary ? 'block' : 'flex'}
      minH="75px"
      justifyContent={{ xl: 'center' }}
      lineHeight="25.6px"
      mx="auto"
      mt={secondaryMargin}
      pb="8px"
      right={{ base: '12px', md: '30px', lg: '30px', xl: '30px' }}
      px={{
        sm: paddingX,
        md: '10px',
      }}
      ps={{
        xl: '12px',
      }}
      pt="8px"
      top={{ base: '12px', md: '16px', xl: '18px' }}
      w={
        sidebarCollapsed
          ? {
              base: 'calc(100% - 100px)',
              md: 'calc(100% - 100px)',
              lg: 'calc(100% - 100px)',
              xl: 'calc(100% - 100px)',
              '2xl': 'calc(100% - 115px)',
            }
          : mini === false
          ? {
              base: 'calc(100% - 350px)',
              md: 'calc(100% - 350px)',
              lg: 'calc(100% - 350px)',
              xl: 'calc(100% - 350px)',
              '2xl': 'calc(100% - 365px)',
            }
          : mini === true && hovered === true
          ? {
              base: 'calc(100% - 350px)',
              md: 'calc(100% - 350px)',
              lg: 'calc(100% - 350px)',
              xl: 'calc(100% - 350px)',
              '2xl': 'calc(100% - 365px)',
            }
          : {
              base: 'calc(100% - 185px)',
              md: 'calc(100% - 185px)',
              lg: 'calc(100% - 185px)',
              xl: 'calc(100% - 185px)',
              '2xl': 'calc(100% - 200px)',
            }
      }
    >
      <Flex
        w="100%"
        flexDirection={{
          sm: 'column',
          md: 'row',
        }}
        alignItems={{ xl: 'center' }}
        mb={gap}
      >
        <Box mb={{ sm: '8px', md: '0px' }}>
          <Text
            mb={{ sm: '8px', md: '10px' }}
            color={secondaryText}
            fontWeight={500}
          >
            {secondary}
          </Text>
          {/* <Breadcrumb>
            <BreadcrumbItem color={secondaryText} fontSize="sm" mb="5px">
              <BreadcrumbLink href="#" color={secondaryText}>
                Pages
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem color={secondaryText} fontSize="sm">
              <BreadcrumbLink href="#" color={secondaryText}>
                {brandText}
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb> */}
          {/* Here we create navbar brand, based on route name */}
          <Text
            color={mainText}
            href="#"
            bg="inherit"
            borderRadius="inherit"
            fontWeight="bold"
            fontSize="34px"
          >
            {brandText}
          </Text>
        </Box>
        <Box ms="auto">
          <IconButton
            as="a"
            href="/help"
            target="_blank"
            rel="noopener noreferrer"
            icon={<QuestionIcon />}
            aria-label="Help"
            variant="ghost"
            size="md"
            color={mainText}
            _hover={{
              bg: useColorModeValue('gray.100', 'whiteAlpha.200'),
            }}
          />
        </Box>
        {/* <Box ms="auto" w={{ sm: '100%', md: 'unset' }}>
          <AdminNavbarLinks
            mini={mini}
            setMini={setMini}
            theme={theme}
            setTheme={setTheme}
            secondary={props.secondary}
          />
        </Box> */}
      </Flex>
    </Box>
  );
}
